import React from 'react';
import { connect } from 'react-redux'

import Icon from '@mdi/react';
import { mdiPanHorizontal } from '@mdi/js';

import { _ } from '../../functions/translator'

class EnlargeTunnelButton extends React.Component{
          
    handleClick = () => {
        let url = `${window.location.origin}/generate-lineal-cardsgroups?project_id=${window.project_id}&cards_group_id=${this.props.cardsGroupIds[0]}`;
        window.open(url);
    }

    render(){   

        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiPanHorizontal } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Agregar Tramo') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

export default connect(mapStateToProps)(EnlargeTunnelButton)